import React from 'react';

const ChatSuggestions = ({ suggestions, onSelect }) => {
    if (!suggestions || suggestions.length === 0) return null;

    return (
        <div className="roxy-panel__suggestions">
            {suggestions.map((suggestion, idx) => (
                <button
                    type="button"
                    key={idx}
                    className="roxy-panel__suggestion"
                    onClick={() => onSelect(suggestion)}
                >
                    {suggestion}
                </button>
            ))}
        </div>
    );
};

export default ChatSuggestions;
